// frontend/user/src/components/file-section-toolbar.tsx
// .pen UUYuk(bi8Au 页面-文件)/ BYeJZ(tC8FY 文件夹详情)sectionHeader:
//   titleGroup(标题+计数)↔ actions([多选, 排序] 胶囊按钮)。
// 字号按 frameId 推导:BYeJZ(17/13)/ UUYuk(19/15)。

type Props = {
  frameId: 'UUYuk' | 'BYeJZ'
  title: string
  count: number
  onMultiSelect: () => void
  onSort: () => void
}

const PILL =
  'flex items-center gap-1.5 rounded-[14px] bg-[#F6F7F8] px-2.5 py-1.5 text-[12px] font-medium text-[#6B7280] active:bg-[#EDEEF0]'

export function FileSectionToolbar({ frameId, title, count, onMultiSelect, onSort }: Props) {
  const dense = frameId === 'BYeJZ' // BYeJZ(文件夹详情)走 17/13 字号,UUYuk 走 19/15
  return (
    <div data-testid={frameId} className="flex items-center justify-between px-6 pt-4 pb-4">
      <div className="flex items-baseline gap-2">
        <h2 className={`font-semibold text-[#1A1A1A] ${dense ? 'text-[17px]' : 'text-[19px]'}`}>{title}</h2>
        <span className={`text-[#9CA3AF] ${dense ? 'text-[13px]' : 'text-[15px]'}`}>{count} 项</span>
      </div>
      <div className="flex items-center gap-2">
        <button type="button" data-testid={`${frameId}-multi-btn`} aria-label="多选" onClick={onMultiSelect} className={PILL}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m3 17 2 2 4-4" /><path d="m3 7 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" />
          </svg>
          多选
        </button>
        <button type="button" data-testid={`${frameId}-sort-btn`} aria-label="排序" onClick={onSort} className={PILL}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m21 16-4 4-4-4" /><path d="M17 20V4" /><path d="m3 8 4-4 4 4" /><path d="M7 4v16" />
          </svg>
          排序
        </button>
      </div>
    </div>
  )
}
